import { getApolloContext } from "@apollo/client";
import { useContext, useEffect, useState } from "react";

import {
  MODULE_SEARCH,
  REFERENCE_SEARCH,
} from "../../../graphql/query/ReferenceSearch";
import {
  buildSearchRequest,
  selectVisibleResults,
} from "./commandPaletteSearch";

const searchDelayMilliseconds = 120;

const searchDocuments = {
  module: { query: MODULE_SEARCH, field: "moduleSearch" },
  reference: { query: REFERENCE_SEARCH, field: "referenceSearch" },
};

// Reads the client from context rather than `useApolloClient`, so the palette
// still renders where there is no ApolloProvider and simply skips the search.
const useCommandPaletteSearch = ({ query, searchModule }) => {
  const { client } = useContext(getApolloContext());
  const request = client ? buildSearchRequest({ query, searchModule }) : null;
  const [response, setResponse] = useState({
    key: "",
    group: "",
    results: [],
  });
  const requestKey = request?.key;

  useEffect(() => {
    if (!request) return undefined;
    const pending = { cancelled: false };
    const { query: document, field } = searchDocuments[request.kind];
    const settle = results =>
      !pending.cancelled &&
      setResponse({ key: request.key, group: request.group, results });
    const timer = setTimeout(() => {
      client
        .query({
          query: document,
          variables: request.variables,
          fetchPolicy: "cache-first",
        })
        .then(({ data }) => settle(data?.[field] ?? []))
        .catch(() => settle([]));
    }, searchDelayMilliseconds);

    return () => {
      pending.cancelled = true;
      clearTimeout(timer);
    };
    // The request is rebuilt every render; its key captures everything it sends.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [client, requestKey]);

  return {
    results: selectVisibleResults(request, response),
    loading: Boolean(request) && response.key !== request.key,
  };
};

export { useCommandPaletteSearch };
